import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { User } from 'src/app/models/users.model';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { NbToastrService } from '@nebular/theme';
import { COUNTRY_OPTIONS, CountryOption } from 'src/app/shared/constants';
import { CountryCode } from 'src/app/models/country.enum';
import { UserService } from 'src/app/shared/services/user.service';

const firestore = firebase.firestore;

@Component({
  selector: 'app-profile-completion',
  templateUrl: './profile-completion.component.html',
  styleUrls: ['./profile-completion.component.scss'],
})
export class ProfileCompletionComponent implements OnInit {
  loading = false;
  countryOptions = COUNTRY_OPTIONS;
  user: User | null = null;

  formData: {
    mobile: string;
    country: CountryOption;
    companyName: string;
    termsAndConditions: boolean;
  } = {
    mobile: '',
    country: this.countryOptions[0],
    companyName: '',
    termsAndConditions: false,
  };

  constructor(
    private toastr: NbToastrService,
    private router: Router,
    private auth: AngularFireAuth,
    private userService: UserService,
  ) {}

  async ngOnInit() {
    // Get current user
    const authUser = await this.auth.currentUser;
    if (authUser) {
      const userDoc = await firestore().doc(`users/${authUser.uid}`).get();
      this.user = userDoc.data() as User;

      // Pre-fill any existing data
      if (this.user.mobile) this.formData.mobile = this.user.mobile;
      if (this.user.companyName) this.formData.companyName = this.user.companyName;
      if (this.user.countryCode) {
        const country = this.countryOptions.find((c) => c.code === this.user!.countryCode);
        if (country) this.formData.country = country;
      }
    }
  }

  async onSubmit() {
    if (!this.user) return;

    this.loading = true;

    try {
      // Update user profile
      const updates: Partial<User> = {
        mobile: this.formData.mobile,
        countryCode: this.formData.country.code,
        companyName: this.formData.companyName,
        agreedToTerms: this.formData.termsAndConditions,
        profileIncomplete: false,
      };

      await this.userService.updateProfile(this.user.uid, updates);

      this.router.navigate(['/home/convert']);
    } catch (error) {
      this.toastr.warning(error.message || error, 'Error updating profile');
      console.error(error);
    }

    this.loading = false;
  }
}
